import { createSlice } from '@reduxjs/toolkit'

// Mismo corte que usa CoreUI para pasar el sidebar a modo móvil (breakpoint lg).
export const MEDIA_ANCHA = '(min-width: 992px)'
export const esAncha = () =>
  typeof window === 'undefined' || !window.matchMedia || window.matchMedia(MEDIA_ANCHA).matches

export const sidebarSlice = createSlice({
  name: 'sidebar',
  // Abierto de entrada solo en pantallas anchas: por debajo de lg (tablet, móvil) CoreUI lo
  // muestra como capa encima del contenido y debe empezar cerrado, o el primer toque del botón
  // no hace nada visible.
  initialState: {
    value: esAncha(),
  },
  reducers: {
    toogle: (state) => {
      state.value = !state.value
    },
    setSidebarShow: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { toogle, setSidebarShow } = sidebarSlice.actions

export const selectSidebarShow = (state) => state.sidebar.value

export default sidebarSlice.reducer
